module.exports = __webpack_public_path__ + "static/img/1588_phase_function_Paper_PointsHejduk_Prediction.d656592.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1588_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Xc4P
// module chunks = 0